<div class="mobile-filters">
    <div class="filter-group" *ngFor="let group of filterGroups">
        <span class="group">{{labels.filterGroups[group.type]}}</span>
        <div class="filters" *ngFor="let filter of group.filters">
            <wdpr-checkbox
                class="checkbox"
                alignment="top"
                [checked]="filter.selected"
                (checked-changed)="onCheck($event, filter)">
                {{filter.label}}
            </wdpr-checkbox>
        </div>
    </div>
    <finder-button theme="primary" (click)="dismiss()">{{labels.mobileFilters.buttonText}}</finder-button>
</div>
